/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Banner action size enumeration.
 */
export type BannerSize = typeof BannerSize[keyof typeof BannerSize];


export const BannerSize = {
  large: 'large',
  small: 'small',
} as const;
